import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import {Sabko} from '../App';
import '../style/Formcom.css';

function Skills() {
  const navigate=useNavigate();
    const {state,dispatch}=useContext(Sabko);
    const[Value,setValue]=useState({})
    
    const changeVal=(e)=>{
      const name=e.target.name;
      const value=e.target.value;
      setValue((prev)=>({...prev,[name]:value}))
  
    }
  
    const submitPersoal=(e)=>{
      e.preventDefault();
      if(Object.keys(Value).length===0 && !state.User?.Skills){
        navigate('/') 
      }else{
        dispatch({type:"SKILLS",payload:{...Value} });
        navigate('/') 
      }
    }
  return (
    <div className='main'>

        <form className='Homediv'>
        
            <div className='inputdiv'>
            <label htmlFor='skill1' className='inputLabel'>Skill 1</label>
            <input type='text'  id='skill1' name='skill1'
             value={(Value.skill1)||((Value.skill1==="")?(""):(state.User?.Skills?.skill1) || (""))} 
             className='inputContent' onChange={changeVal}/>
            </div>
            <div className='inputdiv'>
            <label htmlFor='skill2' className='inputLabel'>Skill 2</label>
            <input type='text'  id='skill2' name='skill2'
             value={(Value.skill2)||((Value.skill2==="")?(""):(state.User?.Skills?.skill2) || (""))} 
             className='inputContent' onChange={changeVal}/>
            </div>
            <div className='inputdiv'>
            <label htmlFor='skill3' className='inputLabel'>Skill 3</label>
            <input type='text'  id='skill3' name='skill3'
             value={(Value.skill3)||((Value.skill3==="")?(""):(state.User?.Skills?.skill3) || (""))} 
             className='inputContent' onChange={changeVal}/>
            </div>
            <div className='inputdiv'>
            <label htmlFor='skill4' className='inputLabel'>Skill 4</label>
            <input type='text'  id='skill4' name='skill4'
             value={(Value.skill4)||((Value.skill4==="")?(""):(state.User?.Skills?.skill4) || (""))} 
             className='inputContent' onChange={changeVal}/>
            </div>


            <div className='saveDiv'>
            <Button variant="contained" type='submit' className='saveButt' onClick={submitPersoal}>
            Save</Button>
            </div>

        </form>
        </div> 
  )
}

export default Skills